/* custom-product.js
   Simpele next/prev controls: werkt door de scrollLeft te veranderen.
*/
document.addEventListener('DOMContentLoaded', function () {
  // mogelijke selectors - probeer de eerste die op jouw thema past
  var gallerySelectors = [
    '.product__media-list',
    '.product-media-list',
    '.product-gallery__viewport',
    '.js-product-media',
    '.product-single__photos'
  ];

  var container = null;
  for (var i = 0; i < gallerySelectors.length; i++) {
    var el = document.querySelector(gallerySelectors[i]);
    if (el) { container = el; break; }
  }
  if (!container) return;

  // maak pijltjes element (één keer)
  function makeArrow(className, text) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cp-arrow ' + className;
    btn.setAttribute('aria-label', text);
    btn.innerHTML = (text === 'prev') ? '&#9664;' : '&#9654;'; // ◄ ►
    return btn;
  }

  var prevBtn = makeArrow('cp-arrow--prev', 'prev');
  var nextBtn = makeArrow('cp-arrow--next', 'next');

  // container position: relative voor absolute buttons (zorg dat parent position correct heeft)
  var parent = container.closest('.product-single') || container.parentElement;
  if (parent) {
    parent.style.position = parent.style.position || 'relative';
    parent.appendChild(prevBtn);
    parent.appendChild(nextBtn);
  } else {
    // fallback: append to body
    document.body.appendChild(prevBtn);
    document.body.appendChild(nextBtn);
  }

  // click handlers: scroll by container.clientWidth (1 slide)
  function scrollNext() {
    var width = container.clientWidth;
    container.scrollTo({ left: container.scrollLeft + width, behavior: 'smooth' });
  }
  function scrollPrev() {
    var width = container.clientWidth;
    container.scrollTo({ left: container.scrollLeft - width, behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', scrollPrev);
  nextBtn.addEventListener('click', scrollNext);

  // tactile swipe: geen extra nodig (native scroll)
  // optioneel: verbergen van pijltjes indien slechts 1 slide
  function updateArrowVisibility() {
    if (container.scrollWidth <= container.clientWidth + 5) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    } else {
      prevBtn.style.display = '';
      nextBtn.style.display = '';
    }
  }
  updateArrowVisibility();
  window.addEventListener('resize', updateArrowVisibility);
});
